const create = (api) => {
  const checkOutAssets = (data) => api.post('/inventories/opintel/checkout-commands', data)
  const checkInAssets = (data) => api.post('/inventories/opintel/checkin-commands', data)

  return {
    checkOutAssets,
    checkInAssets
  }
}

export default {
  create
}
